import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { DetailBox } from "../../molecules/DetailBox";
import { QuantamVideo } from "container/QuantamVideo";
import { SmallHadding } from "molecules/SmallHeadding";
import { Paginator } from "primereact/paginator";
import styled from "styled-components";
import "primeicons/primeicons.css";
import "./item.css";

const CustPaginator = styled(Paginator)`
  .p-paginator-first:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-prev:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-next:not(.p-disabled):not(.p-highlight):hover,
  .p-paginator-last:not(.p-disabled):not(.p-highlight):hover {
    color: #000;
  }

  .p-paginator-pages {
    margin: 0 1rem;
  }
  .p-paginator-pages .p-paginator-page.p-highlight {
    background: #010101;
    border-color: #010101;
    color: #fff;
    cursor: default;
  }

  .p-paginator-pages .p-paginator-page {
    border: none;
    border-radius: 50% !important;
    color: #010101;
    float: left;
    font-size: 18px;
    font-weight: 500;
    height: 2pc;
    line-height: 2pc;
    min-width: 2pc;
    padding: 0 !important;
    text-align: center;
    text-decoration: none;
  }

  .p-paginator-pages .p-paginator-page:hover {
    background: #010101;
    color: #fff;
    text-decoration: none;
  }
`;

const ItemTag = styled.div`
  .cust-title {
    font-size: 20px !important;
  }

  .cust-title:hover {
    text-decoration: underline;
    cursor: pointer;
  }
`;

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "1000px",
  },
};

Modal.setAppElement("#root");

const ItemSliderProjects = ({ slidingData, scrollToProjectId }) => {
  const sliderdata = slidingData;

  console.log("sliderdatasliderdatasliderdata", sliderdata);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(12); // Set to 9 for max items per page
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [currentModalData, setCurrentModalData] = useState(null);

  const openModal = (item) => {
    setCurrentModalData(item);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const onPageChange = (event) => {
    setFirst(event.first);
    setRows(event.rows);
  };

  const projectIdsKey = Array.isArray(sliderdata)
    ? sliderdata.map((p) => p?.id).join(",")
    : "";

  useEffect(() => {
    if (!scrollToProjectId || !Array.isArray(sliderdata) || sliderdata.length === 0) {
      return undefined;
    }
    const idx = sliderdata.findIndex(
      (p) => String(p?.id) === String(scrollToProjectId)
    );
    if (idx < 0) return undefined;
    const perPage = rows || 12;
    const pageFirst = Math.floor(idx / perPage) * perPage;
    setFirst(pageFirst);
    const t = window.setTimeout(() => {
      document
        .getElementById(`project-card-${scrollToProjectId}`)
        ?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 400);
    return () => window.clearTimeout(t);
  }, [scrollToProjectId, projectIdsKey, rows]);

  const itemTemplate = (item, index) => {
    return (
      <div
        id={item?.id != null ? `project-card-${item.id}` : undefined}
        className="col-lg-12 col-md-3 col-sm-12  mb-0 insightDiv "
        key={index}
        style={{ flex: "0 0 33.33%" }}
      >
        {" "}
        {/* Bootstrap classes for three columns */}
        <div
          className=" w-full"
          style={{ cursor: "pointer" }}
          onClick={() => openModal(item)}
        >
          <ItemTag className="divSpacing">
            {item?.Images ? (
              <div
                className="image-container"
                data-aos="fade-up"
                data-aos-duration="1500"
              >
                <img
                  src={item?.Images}
                  className="w-100  .zoom-image"
                  alt="Slider Item zoom-image"
                  style={{ borderRadius: "0px" }}
                />
              </div>
            ) : (
              <></>
            )}
              {item?.title && (
              <p
                data-aos="fade-up"
                className={`underlineText mb-0 font-bold projectDescription ${
                  index === 0 || index === 4 || index === 8
                    ? "projectDescription"
                    : "projectDescriptionsecond"
                }`}
              >
                {item?.title}
              </p>
            )}

            {item?.location && (
              <p
                data-aos="fade-up"
                className={`underlineText mb-4 mt-1 projectDescription ${
                  index === 0 || index === 4 || index === 8
                    ? "projectDescription"
                    : "projectDescriptionsecond"
                }`}
              >
                {item?.description?.length > 100
                  ? item.description.slice(0, 100) + "..."
                  : item.location}
              </p>
            )}
          </ItemTag>
        </div>
      </div>
    );
  };

  // Calculate the paginated items based on current page
  const paginatedItems = sliderdata?.slice(first, first + rows);

  return (
    <>
      <div className="row projectPadding">
        {" "}
        {paginatedItems.map((item, index) => {
          return (
            <div className="col-lg-3 col-md-4 col-sm-6 p-0 " key={item?.id ?? index}>
              {itemTemplate(item, index)}
            </div>
          );
        })}
      </div>
      <div className="d-flex justify-content-end" style={{ width: "100%" }}>
        <CustPaginator
          first={first}
          rows={rows}
          totalRecords={sliderdata?.length} // Total records for pagination
          rowsPerPageOptions={[4, 9]} // Adjust as needed
          onPageChange={onPageChange}
          prevPageLinkIcon={
            <i
              className="pi pi-arrow-circle-left"
              style={{ fontSize: "2rem" }}
            ></i>
          }
          nextPageLinkIcon={
            <i
              className="pi pi-arrow-circle-right"
              style={{ fontSize: "2rem" }}
            ></i>
          }
          currentPageReportTemplate="{currentPage} of {totalPages}"
          template={{ layout: "PrevPageLink CurrentPageReport NextPageLink" }}
        />
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Project Detail Modal"
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #C82027",
            marginBottom: "20px",
            width: "100%",
          }}
        >
          <p style={{ fontWeight: "500", fontSize: "20px" }}>
          {currentModalData?.title}
          </p>
          <button
            onClick={closeModal}
            className="btn bg-transparent border-none shadow-none p-1 cursor-pointer text-center"
          >
            <i className="pi pi-times float-right thm-red fs-25"></i>
          </button>
        </div>

        <div className="containerNew" style={{ alignItems: "flex-start" }}>
          <div className="column1 pt-3" style={{ padding: 0 }}>
            <div className="mb-3">
              <div className="d-flex flex-wrap">
                <div className="mb-3 font17 w-50">
                  <p className="fw-bold mb-0">Project Type:</p>
                  <span className="font17">
                    {currentModalData?.project_type}
                  </span>
                </div>
                <div className="w-50">
                  <p className="fw-bold font17 mb-0">Location:</p>
                  <span className="font17"> {currentModalData?.location}</span>
                </div>
                <div className="w-50">
                  <p className="fw-bold font17 mb-0">Service:</p>
                  <span className="font17">{currentModalData?.service}</span>
                </div>
                <div className="w-50">
                  <p className="fw-bold font17 mb-0">Year:</p>
                  <span className="font17">{currentModalData?.year}</span>
                </div>
              </div>
            </div>
            <p className="font17">{currentModalData?.description}</p>
          </div>

          <div className="column1 image-container position-relative">
            <img
              src={currentModalData?.Images}
              alt="Popup Slider"
              className="w-100"
            />
          </div>
        </div>
      </Modal>

      <style jsx>{`
        @media (max-width: 768px) {
          .column1 {
            flex-direction: column;
            width: 100%;
          }
          .w-50 {
            width: 100% !important;
          }
          .mb-0 {
            margin-bottom: 10px !important;
          }
          .fw-bold {
            font-weight: 600;
          }
        }
      `}</style>
    </>
  );
};

export default ItemSliderProjects;
